import escape from 'escape-html'
import adjustInfoVertical from '../../utils/adjustInfoVertical'


export class FontControl {
  constructor (element, svg) {
    this.$control = document.createElement('div')
    this.$control.classList.add('si_controls__control')
    this.$control.classList.add('si_control')
    this.$control.classList.add('si_control--fontSize')

    const $label = document.createElement('label')
    $label.classList.add(`si_control__label`)
    if(document.documentElement.lang == 'en'){
      $label.innerHTML = 'Font size'
    }else{
      $label.innerHTML = 'Taille de la police'
    }
    

    this.$input = document.createElement('input')
    this.$input.classList.add('si_control__input')
    this.$input.classList.add('si_input')
    this.$input.classList.add('si_input--font-size')
    this.$input.setAttribute('type', 'number')
    this.$input.setAttribute('step', '1')
    this.$input.setAttribute('pattern', '[0-9]*')

    this.origValue = Math.round(getComputedStyle(element.node, null).fontSize.replace('px', ''))
    this.setValue(this.origValue)

    this.$input.addEventListener('input', (e) => {
      const value = Number.parseInt(e.target.value, 10)
      var bisElement = element.attr('si:bis') ? true : false
      
      element.node.style.fontSize = `${value}px`
      adjustInfoVertical(element, false);
      if (bisElement) {
          var bisName = escape(element.attr('si:bis'));
          var bisElem = svg.select(bisName + ' text');
          //
          bisElem.node.style.fontSize = `${value}px`
          adjustInfoVertical(bisElem, true);
        }
    })

    this.$input.addEventListener('change', (e) => {
      const value = Number.parseInt(e.target.value, 10)
      var bisElement = element.attr('si:bis') ? true : false
      
      element.node.style.fontSize = `${value}px`
      adjustInfoVertical(element, false);
      if (bisElement) {
          var bisName = escape(element.attr('si:bis'));
          var bisElem = svg.select(bisName + ' text');
          //
          bisElem.node.style.fontSize = `${value}px`
          adjustInfoVertical(bisElem, true);
        }

    })

    element.node.addEventListener('fontSizeChange', (e) => {
      this.setOrigValue(Math.round(getComputedStyle(element.node, null).fontSize.replace('px', '')))
       adjustInfoVertical(element, true);
    })

    this.$control.appendChild($label)
    $label.appendChild(this.$input)

    this.reset = this.reset.bind(this, element)

    return this
  }

  getElement() {
    return this.$control
  }

  setValue(value) {
    this.$input.value = value
    return this
  }

  setOrigValue(value) {
    this.origValue = value
    this.setValue(this.origValue)
    return this
  }

  getValue() {
    return Number.parseInt(this.$input.value, 10)
  }

  reset(element) {
    element.node.style.fontSize = this.origValue

    this.setValue(this.origValue)

    return this
  }
}
